<template>
    <div>
        <contentbox @close="close">
            <template slot="content">
                <div class="table-container">
                    <div class="title">设备列表</div>

                    <div class="searchBox">
                        <input class="serchList" type="text" v-model="searchText" placeholder="输入设备名称或设备别名" />
                        <select class="serchList select-box" v-model="searchStatus">
                            <option value="">报警状态</option>
                            <option :value="1">报警</option>
                            <option :value="0">正常</option>
                        </select>
                        <select class="serchList select-box" v-model="searchMaintain">
                            <option value="">维护状态</option>
                            <option value="1">维护</option>
                            <option value="0">正常</option>
                        </select>
                        <select class="serchList select-box" v-model="searchProject">
                            <option value="">项目ID</option>
                            <option v-for="(item, index) in searchProjectOption" :key="index" :value="item">{{ item }}
                            </option>
                        </select>
                        <select class="serchList select-box" v-model="searchType">
                            <option value="">设备类型</option>
                            <option v-for="(item, index) in searchTypeOption" :key="index" :value="item">{{ item }}
                            </option>
                        </select>
                        <div class="queryBtn" @click="queryAll">重置</div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>设备名称</th>
                                <th>项目ID</th>
                                <th>设备别名</th>
                                <th>更新时间</th>
                                <th v-if="deviceType == '积水监测'">电压</th>
                                <th v-if="deviceType == '积水监测'">信号强度</th>
                                <th>报警状态</th>
                                <th>维护状态</th>
                                <th>在线状态</th>
                                <th>设备类型</th>
                                <th>查看详情</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in filteredDevices" :key="index"
                                v-if="item.deviceName != 'J8C149912846VK53'">
                                <td>{{ item.deviceName }}</td>
                                <td>{{ item.projectId }}</td>
                                <td>{{ item.anotherName ? item.anotherName : '未设置' }}</td>
                                <td>{{ item.updatetime }}</td>
                                <td v-if="item.deviceType == '积水监测'">{{ item.BatteryRemain }}V</td>
                                <td v-if="item.deviceType == '积水监测'">{{ item.signal }}dbm</td>
                                <td :class="item.alarmStatus ? 'alarmStyle' : ''">{{ item.alarmStatus ? '报警' : '正常' }}
                                </td>
                                <td :class="item.maintain == '1' ? 'mainStyle' : ''">{{ item.maintain == '1' ? '维护' :
                                    '正常'
                                    }}</td>
                                <td :class="item.onlineStatus == 2 ? 'alarmStyle' : ''">{{ item.onlineStatus == 2 ? '离线'
                                    :
                                    '在线' }}</td>

                                <td>{{ item.deviceType }}</td>
                                <td @click="deviceDetail(item)" class="detail">查看详情</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </contentbox>
    </div>
</template>

<script>
import contentbox from '@/components/common/maxWeb/contentbox.vue';
import moment from 'moment/moment';
export default {
    props: {
        data: Array
    },
    data() {
        return {
            deviceType: '',
            searchText: '',
            searchStatus: '',
            searchMaintain: '',
            searchType: '',
            searchTypeOption: this.$store.state.deviceTypeArr,
            searchProject: '',
            searchProjectOption: []
        };
    },
    methods: {
        // 重置全部设备
        queryAll() {
            this.searchText = '';
            this.searchStatus = '';
            this.searchMaintain = '';
            this.searchType = '';
            this.searchProject = '';
        },
        // 打开设备详情
        deviceDetail(e) {
            console.log(e);
            this.$emit('deviceDeatil', e);
        },
        // 关闭卡片
        close() {
            this.$emit('close');
        }
    },
    created() {
        this.searchProjectOption = this.data.reduce((pre, cur) => {
            if (!pre.includes(cur.projectId)) {
                return pre.concat(cur.projectId)
            } else {
                return pre
            }
        }, [])
    },
    computed: {
        filteredDevices() {
            console.log(this.data, 'this.data');
            this.deviceType = this.data[0].deviceType
            return this.data.filter((device) => {
                let matched = true;
                if (this.searchText) {
                    const searchTextLower = this.searchText.toLowerCase().trim();
                    matched =
                        device.deviceName.toLowerCase().includes(searchTextLower) ||
                        (device.anotherName && device.anotherName.toLowerCase().includes(searchTextLower));
                }

                if (new Date().getTime() - device.updateTime > 259200000) {
                    device.onlineStatus = 2
                } else {
                    device.onlineStatus = 1
                }
                device.updatetime = moment(device.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');

                if (matched && this.searchStatus !== '') {
                    matched = device.alarmStatus === this.searchStatus;
                    console.log(matched);
                }

                if (matched && this.searchMaintain !== '') {
                    matched = device.maintain === this.searchMaintain;
                }

                if (matched && this.searchType) {
                    matched = device.deviceType === this.searchType;
                }
                if (matched && this.searchProject) {
                    matched = device.projectId === this.searchProject;
                }
                return matched;
            });
        }
    },
    components: {
        contentbox
    }
};
</script>

<style lang="less" scoped>
.table-container {
    width: 100%;
    margin: 0 auto;
    font-size: 16px;

    .title {
        color: #fff;
        font-weight: bold;
        letter-spacing: 2px;
        font-size: 17px;
        padding-left: 5px;
        margin-bottom: 10px;
        box-sizing: border-box;
        border-left: 5px solid #06ffb4;
    }
}

.searchBox {
    padding: 10px 0;
    display: flex;
    justify-content: right;

    .serchList {
        margin-left: 10px;
    }

    .select-box {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        height: 30px;
        padding: 5px;
        font-size: 12px;
        border: none;
        outline: none;
        cursor: pointer;
    }

    .queryBtn {
        padding: 5px;
        background-color: #fff;
        color: #000;
        box-sizing: border-box;
        font-size: 12px;
        display: flex;
        align-items: center;
        height: 30px;
        margin-left: 10px;
        margin-right: 10px;
        transition: all 0.5s;
        cursor: pointer;
    }
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 10px;
    text-align: left;
    border: 1px solid #fff;

    background-color: transparent;
    text-align: center;
    color: #fff;
}

th {
    background-color: #2392ff;
    font-weight: bold;
}

.alarmStyle {
    color: red;
}

.mainStyle {
    color: orange;
}

.detail {
    cursor: pointer;
    transition: all 0.3s;
}

.detail:hover {
    color: #2392ff;
}
</style>